import { getFileExtension } from './get-file-extension';
import { isValidUrl } from '../routes/urls';

export const getFileExtensionByUrl = (url: string) => {
    const pathname = isValidUrl(url) ? new URL(url).pathname : url;
    return getFileExtension(pathname.toLowerCase());
};
